module.exports = __webpack_public_path__ + "img/Gu_Shuo.6ba18779.jpg";